import { getCurrentMembers, getAlumni } from '../../lib/people.js';
import { useDocumentTitle } from '../../lib/useDocumentTitle.js';

function PersonCard({ person }) {
  return (
    <li>
      <h3>{person.name}</h3>
      <p className="meta">
        {person.role} · Batch of {person.batch}
      </p>
      {person.achievements?.length > 0 && (
        <ul>
          {person.achievements.map((achievement) => (
            <li key={achievement}>{achievement}</li>
          ))}
        </ul>
      )}
    </li>
  );
}

export default function PeoplePage() {
  useDocumentTitle('People');
  const current = getCurrentMembers();
  const alumni = getAlumni();

  return (
    <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
      <h1>People</h1>
      <p className="meta">
        Current members and alumni of YACC, and what they&apos;ve achieved.
      </p>

      <section className="section-marked" style={{ marginTop: '2rem' }}>
        <h2>Current members</h2>
        <ul className="hairline-list">
          {current.map((person) => (
            <PersonCard key={person.slug} person={person} />
          ))}
        </ul>
      </section>

      <section className="section-marked" style={{ marginTop: '2rem' }}>
        <h2>Alumni</h2>
        <ul className="hairline-list">
          {alumni.map((person) => (
            <PersonCard key={person.slug} person={person} />
          ))}
        </ul>
      </section>
    </div>
  );
}
